module.exports = __webpack_public_path__ + "static/media/profile_details_blue.d17abaf0.svg";